import { Box, colors, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { authedAxios } from '../../../utils'
import { pickTextColorBasedOnBgColorSimple } from '../../../utils/color'
import { Info } from '@mui/icons-material'

const PipelineSummary = ({ customerPipelineSummary, customer }) => {
  const { isLoading, hasLoadError, pipelines } = customerPipelineSummary

  if (isLoading || hasLoadError) return null

  const updateOpportunityStage = (stageId) => {
    return authedAxios
      .put(`/api/customer/${customer.id}/stage/opportunities/${stageId}`)
      .then(customerPipelineSummary.refetch)
      .catch(() => {})
  }

  const updateCustomerStage = (pipelineId, stageId) => {
    if (pipelineId === '__OPPORTUNITIES__')
      return updateOpportunityStage(stageId)

    return authedAxios
      .put(`/api/customer/${customer.id}/stage/${stageId}`)
      .then(customerPipelineSummary.refetch)
      .catch(() => {})
  }

  return pipelines.map((p, i) => {
    const activeStageDisplayOrder = p.stages.find(
      (s) => s.customerIsInStage
    ).displayOrder

    return (
      <Box key={p.id} sx={{ my: 1, maxWidth: '1250px', flexGrow: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <Typography>
            <b>{p.name}</b>
          </Typography>

          {i === 0 && (
            <Tooltip
              sx={{ ml: 1 }}
              title={
                <Typography sx={{ fontSize: '18px' }}>
                  {
                    'Click any of the stages below to move this account into that stage.'
                  }
                </Typography>
              }
            >
              <Info color='primary'></Info>
            </Tooltip>
          )}
        </Box>
        <Box sx={{ display: 'flex', flexGrow: 1 }}>
          {p.stages.map((s, i) => {
            const isActive = s.displayOrder <= activeStageDisplayOrder

            const normalizedColors = { ...colors, gray: colors.grey }
            const backgroundColor =
              normalizedColors[s.color][isActive ? 400 : 50]

            const borderColor = normalizedColors[s.color][isActive ? 900 : 50]

            const textColor =
              pickTextColorBasedOnBgColorSimple(
                backgroundColor,
                '#ffffff',
                '#000000'
              ) + (isActive ? 'FF' : '99')

            return (
              <Box
                key={s.id}
                sx={{
                  flexGrow: 1,
                  flexShrink: 1,
                  display: 'flex',
                  ml: i !== 0 ? '-25px' : 0,
                  maxWidth: `calc(100%/${p.stages.length} + 25px)`,
                  zIndex: p.stages.length - i,
                }}
              >
                <Box
                  onClick={() => updateCustomerStage(p.id, s.id)}
                  sx={{
                    flexGrow: 1,
                    flexShrink: 1,
                    textAlign: 'center',
                    pt: '4px',
                    zIndex: 1,
                    color: textColor,
                    backgroundColor,
                    border: '3px solid',
                    borderColor,
                    borderRight: 'none',
                    pl: i !== 0 ? '33px' : '8px',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    cursor: 'pointer',
                  }}
                >
                  {s.name}
                </Box>
                {isActive && (
                  <Box
                    sx={{
                      mr: '-29px',
                      flexGrow: 0,
                      flexShrink: 0,
                      width: 0,
                      height: 0,
                      borderTop: '16px solid transparent',
                      borderBottom: '16px solid transparent',
                      borderLeft: `25px solid ${borderColor}`,
                    }}
                  ></Box>
                )}
                <Box
                  sx={{
                    flexGrow: 0,
                    flexShrink: 0,
                    width: 0,
                    height: 0,
                    borderTop: '16px solid transparent',
                    borderBottom: '16px solid transparent',
                    borderLeft: `25px solid ${backgroundColor}`,
                  }}
                ></Box>
              </Box>
            )
          })}
        </Box>
      </Box>
    )
  })
}

export default PipelineSummary
